import { render, staticRenderFns } from "./kims-layout.vue?vue&type=template&id=22600487"
import script from "./kims-layout.vue?vue&type=script&lang=js"
export * from "./kims-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports